import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";


import { Label, Input, FormFeedback } from 'reactstrap';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        label: PropTypes.string,
    }

    render() {
        return (
            <ParadigmaModal
                fileUploader={true}
                postUrl={api.proyectos.config.firmas.create}
                onSubmit={(res) => this.props.onSubmit(res)}
                successMessage={"La Firma ha sido creado con éxito."}
                title={"Nueva Firma"}
                buttonIcon={"fa fa-plus fa-lg"}
                
                buttonLabel={this.props.label}
                saveButton={true}
                closeButton={true}
                className={"ui-modal-dialog ui-modal-md"}>
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Datos de la firma</p>
                        <div className="ui-row-2">
                            <div className="ui-field">
                                <Label>Nombre</Label>
                                <Input type="text" name="nombre" autoFocus data-auto-focus="true"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                            <div className="ui-field">
                                <Label>Cargo</Label>
                                <Input type="text" name="cargo"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Imagen</Label>
                                <Input type="file" name="imagen" accept="image/*"></Input>
                                <Input type="hidden" name="imagen2"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Firmas/Create.js